import { PreloadedQuery } from 'react-relay';
import type { RouteResource } from '@townsquare/router/resources/types';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import ProjectCapabilitiesQuery, {
	ProjectCapabilitiesQuery as ProjectCapabilitiesQueryType,
} from '../components/__generated__/ProjectCapabilitiesQuery.graphql';

export const projectCapabilitiesResource: RouteResource<
	PreloadedQuery<ProjectCapabilitiesQueryType, Record<string, unknown>>
> = createRelayResource<ProjectCapabilitiesQueryType>({
	getQuery: (_, resourceContext) => {
		const containerId = (resourceContext as ResourceContext).collabContext?.contextId ?? '';

		return {
			query: ProjectCapabilitiesQuery,
			environment: getAggRelayEnvironment(),
			variables: {
				containerId,
				isM3GroupPermsEnabled: fg('townsquare_m3_group_permissions'),
			},
		};
	},
});
